/*
 * Add/Remove Class Handler
 *
 **/

import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

require('custom/type-design-id');

custom.classHandler = (() => {
  const breakpoint = 560;

  const addTriggerClass = 'js-class-handler-add';
  const removeTriggerClass = 'js-class-handler-remove';
  const productPanelClass = 'product-panel';
  const sidePanelOpenClass = 'side-panel--open';

  // Checks whether mobile or not
  function isMobile() {
    return (
      (window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth) < breakpoint
    );
  }

  function addOpenClass(e) {
    e.preventDefault();
    const targetSelector = e.target.getAttribute('data-target-dom');
    const openClasses = e.target.dataset.className.split(' ');

    openClasses.forEach((openClass) => {
      if (!$(targetSelector).hasClass(openClass))
        $(targetSelector).addClass(openClass);
    });

    custom.typeDesignId.init();
    if (isMobile()) {
      disableBodyScroll(document.querySelector(targetSelector)); // Lock body Element
    }
    $('.js-modal-overlay').show();
    $('.js-modal-overlay').on('click', clickOutsideToClose);
  }

  function removeOpenClass(e = null, $el = {}) {
    if (e !== null) e.preventDefault();
    const targetSelector = e
      ? e.target.getAttribute('data-target-dom')
      : $el.data().targetDom;
    const openClasses = e
      ? e.target.dataset.className.split(' ')
      : $el.data().className.split(' ');

    openClasses.forEach((openClass) => {
      if ($(targetSelector).hasClass(openClass))
        $(targetSelector).removeClass(openClass);
    });

    clearAllBodyScrollLocks();
    $('.js-modal-overlay').hide();
    $('.js-modal-overlay').off('click', clickOutsideToClose);
  }

  // Click Outside To Close
  // If they click outside side panel, close panel
  function clickOutsideToClose(event = null) {
    const $target = $(event.target);
    if ($target.closest(`.${productPanelClass}`).length) return;
    const $el = $target
      .siblings(`.${productPanelClass}`)
      .find(`.${removeTriggerClass}`);
    removeOpenClass(null, $el);
  }

  function init() {
    $(`.${addTriggerClass}`).on('click', addOpenClass);
    $(`.${removeTriggerClass}`).on('click', function (e) {
      removeOpenClass(e, null);
    });
    //TODO: assess whether this old code watching for any click in the document is necessary or if it can be rewritten
    $(document).on('click', function (e) {
      const $target = $(e.target);
      if (
        $(`.${productPanelClass}`).length &&
        $(`.${addTriggerClass}`).length &&
        !$target.closest(`.${productPanelClass}.${sidePanelOpenClass}`)
          .length &&
        $target.data().targetDom !== $(`.${addTriggerClass}`).data().targetDom
      ) {
        if ($(`.${productPanelClass}`).hasClass(sidePanelOpenClass)) {
          const $el = $target
            .closest('#app')
            .siblings(`.${productPanelClass}`)
            .find(`.${removeTriggerClass}`);
          removeOpenClass(null, $el);
        }
      }
    });
  }

  return {
    init,
  };
})();

custom.classHandler.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/class-handler.js